module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_m_albino.265f0a9b.png";